module.exports = __webpack_public_path__ + "img/tarjeta_map_preview.2bb0a08.png";